import { parsePhoneNumber } from 'react-phone-number-input';

export const getFormattedPhoneNumber = (text: string) => {
  return parsePhoneNumber(text)?.formatInternational() || text;
};
